import { useEffect } from 'react';

interface PageMetaProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  ogImage?: string;
  twitterCard?: string;
  schema?: Record<string, unknown>;
}

export default function PageMeta({
  title = '98堂 入口 - 官方直达通道，安全快速登录',
  description = '98堂 入口是您访问98堂平台的官方直达渠道，提供最新可用地址、安全登录指引及快速入口导航。收藏本页，永不迷路。',
  keywords = '98堂 入口,98堂最新入口,98堂官方入口,98堂登录地址,98堂直达链接,98堂备用入口,98堂网址导航',
  canonicalUrl = 'https://98tang.com',
  ogTitle,
  ogDescription,
  ogType = 'website',
  ogUrl,
  ogImage,
  twitterCard = 'summary_large_image',
  schema,
}: PageMetaProps) {
  const finalOgTitle = ogTitle ?? title;
  const finalOgDescription = ogDescription ?? description;
  const finalOgUrl = ogUrl ?? canonicalUrl;

  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const link = document.querySelector('link[rel="canonical"]');
    if (link) {
      link.setAttribute('href', canonicalUrl);
    }

    setMeta('og:title', finalOgTitle, true);
    setMeta('og:description', finalOgDescription, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', finalOgUrl, true);
    if (ogImage) setMeta('og:image', ogImage, true);

    setMeta('twitter:card', twitterCard);
    setMeta('twitter:title', finalOgTitle);
    setMeta('twitter:description', finalOgDescription);

    if (schema) {
      let scriptEl = document.querySelector('script[type="application/ld+json"][data-page-schema]');
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.setAttribute('type', 'application/ld+json');
        scriptEl.setAttribute('data-page-schema', 'true');
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(schema);
    }
  }, [title, description, keywords, canonicalUrl, finalOgTitle, finalOgDescription, ogType, finalOgUrl, ogImage, twitterCard, schema]);

  return null;
}